<template>
  <span class="toolOption">
    <button type="button" class="toolbarBtn"
      :class="{active: option}"
      @mousedown.prevent
      @click="onClickOption">
      <img src="~@/assets/img/CITEditor/font_size.svg" alt="font size" title="font size" />
    </button>
    <div v-show="option" class="optionGroup">
      <button type="button" class="optionItem"
        v-for="val in size"
        :key="val"
        :style="{fontSize: `${val}px`}"
        :class="{active: val === value}"
        @mousedown.prevent
        @click="onSelectOption($event, val)">{{val}}</button>
    </div>
  </span>
</template>

<script>
export default {
  name: 'FontSize',
  props: [
    'active',
    'value',
    'option'
  ],
  computed: {
    size () {
      return this.$store.getters['citeditor/getFontSize']
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // open option:: fontsize
    onClickOption (e) {
      this.$emit('setOption', { name: 'FontSize', state: true })
    },
    // select option
    onSelectOption (e, val) {
      e.preventDefault()
      const size = `${val}`.includes('default') ? 16 : val
      this.setFontSize(size)
      this.$emit('setValue', { name: 'FontSize', value: val })
    },
    setFontSize (size) {
      const selection = window.getSelection()
      const range = selection.getRangeAt(0)
      const contents = range.cloneContents()
      const span = document.createElement('span')
      const fontSize = `${size}px`
      function findSpan (el) {
        const fontSizeElement = el.querySelectorAll('[style*=font-size]')
        fontSizeElement.forEach(function (x) {
          if (x.style.fontSize !== fontSize) {
            x.style.fontSize = ''
          }
          if (x.innerHTML === '') {
            x.parentNode.removeChild(x)
          }
        })
      }
      span.style.fontSize = fontSize
      span.appendChild(contents)
      findSpan(span)
      range.deleteContents()
      range.insertNode(span)
      if (selection.focusNode.style && selection.focusNode.style.fontSize !== '') {
        selection.focusNode.style.fontSize = ''
      }
      this.emptyFontSize()
    },
    emptyFontSize () {
      const citContents = document.querySelectorAll('.citContents')
      function unwrap (wrapper) {
        const fragment = document.createDocumentFragment()
        while (wrapper.firstChild) {
          const child = wrapper.removeChild(wrapper.firstChild)
          fragment.appendChild(child)
        }
        wrapper.parentNode.replaceChild(fragment, wrapper)
      }
      citContents.forEach(function (contents) {
        const styles = contents.querySelectorAll('[style]')
        styles.forEach(function (style) {
          if (style.style.length === 0) {
            unwrap(style)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.optionItem {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  line-height: 1;
}
</style>
